import data from '@emoji-mart/data'

import supplement from './emoji-supplement.json'

// @emoji-mart/data ships around Unicode 15. Fold in the newer emoji
// (Unicode 15.1–17, generated from emojibase-data — see
// scripts/build-emoji-supplement.mjs) so both the picker and the composer
// `:emoji:` completion can find and insert them (e.g. 🪎 treasure chest,
// Unicode 17.0). Additive only: the base dataset is left untouched.
type EmojiMartData = {
  categories: { id: string; emojis: string[] }[]
  emojis: Record<string, unknown>
  aliases: Record<string, string>
  [key: string]: unknown
}

const base = data as unknown as EmojiMartData
// Shallow-clone the parts we mutate so the shared @emoji-mart/data import is
// never edited in place.
const merged: EmojiMartData = {
  ...base,
  emojis: { ...base.emojis },
  categories: base.categories.map(c => ({ ...c, emojis: [...c.emojis] })),
}

for (const e of supplement) {
  if (merged.emojis[e.id]) {
    continue // never clobber an existing emoji
  }
  merged.emojis[e.id] = {
    id: e.id,
    name: e.name,
    keywords: e.keywords,
    skins: e.skins,
    version: e.version,
  }
  const category = merged.categories.find(c => c.id === e.category)
  if (category && !category.emojis.includes(e.id)) {
    category.emojis.push(e.id)
  }
}

export default merged
